import React from 'react'
import { Link } from 'react-router-dom'
import * as Cookies from "es-cookie";

// Shortcuts to the main study areas, at the bottom of the NEET/JEE home.
// Access rules live on the destination pages, as with the sidebar links;
// userLevel1 links show only to student_userlevel 1, as in the sidebar.
const QUICK_LINKS = [
    { to: "/student/learn-practice", icon: "fa-book-reader", label: "Learn & Practise", tone: "orange" },
    { to: "/student/exams/test-series", icon: "fa-clipboard-check", label: "Mock Tests", tone: "blue" },
    { to: "/student/PreviousPapers", icon: "fa-history", label: "Previous Year Papers", tone: "purple" },
    { to: "/student/exams/error-exam", icon: "fa-redo", label: "Error Exam", tone: "red" },
    { to: "/student/exams/custom-exam", icon: "fa-sliders-h", label: "Custom Exam", tone: "teal" },
    { to: "/student/exams/schedule-exam", icon: "fa-calendar-check", label: "Scheduled Exams", tone: "blue", userLevel1: true },
    { to: "/student/result-analysis", icon: "fa-chart-line", label: "Performance Analysis", tone: "green" },
    { to: "/student/strength-analysis", icon: "fa-dumbbell", label: "Strength Analysis", tone: "purple" },
    { to: "/student/category_wise_videos", icon: "fa-play-circle", label: "Watch & Learn", tone: "red" },
    { to: "/student/bookmark", icon: "fa-bookmark", label: "Bookmarks", tone: "orange" },
    { to: "/student/notes", icon: "fa-sticky-note", label: "Notes", tone: "teal" },
    // { to: "/student/doubts", icon: "fa-question-circle", label: "Ask a Doubt", tone: "green" },
];

const QuickLinks = () => {
    const links = QUICK_LINKS.filter((l) => !l.userLevel1 || Cookies.get("student_userlevel") == 1);
    return (
        <div className="home-quick-links">
            <div className="home-quick-links-head">
                <h5 className="home-quick-links-title mb-0">Quick Links</h5>
                <span className="home-quick-links-sub">Jump straight to what you need</span>
            </div>
            <div className="home-quick-links-grid">
                {links.map((l) => (
                    <Link key={l.to} to={l.to} className={`home-quick-link home-quick-link--${l.tone}`}>
                        <span className="home-quick-link-icon"><i className={`fad ${l.icon}`} aria-hidden="true" /></span>
                        <span className="home-quick-link-label">{l.label}</span>
                        <i className="far fa-chevron-right home-quick-link-go" aria-hidden="true" />
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default QuickLinks;
